<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <search id="header-search" class="right-menu-item" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

      </template>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <!--          <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">-->
          <div class="name-first" :style="{backgroundColor:getNameBg()}">{{ getFirstName() }}</div>
          <div class="name">{{ name }}</div>
          <!--          <i class="el-icon-caret-bottom"/>-->
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="onShowPwd">修改密码</el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="修改密码"
      append-to-body
      width="500px"
      :visible.sync="showPwd"
    >
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="新密码" prop="password">
          <el-input v-model="form['password']" show-password />
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input v-model="form['checkPass']" show-password />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="commitLoading" :loading="commitLoading" @click="onSubmit">保存</el-button>
          <el-button @click="handleClose">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import Search from '@/components/HeaderSearch'
import { changePassword, getPublicKey } from '@/api/user'
import { JSEncrypt } from 'jsencrypt'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    Search
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'device',
      'name'
    ])
  },
  data() {
    return {
      showPwd: false,
      commitLoading: false,
      form: {
        password: '',
        checkPass: ''
      },
      secretKey: '',
      rules: {
        password: [
          { required: true, message: '请输入密码' },
          {
            validator: (rule, value, callback) => {
              if (value.length < 6) {
                callback(new Error('请输入6位数密码'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (this.form.checkPass !== '') {
                this.$refs.ruleForm.validateField('checkPass')
              }
              callback()
            }, trigger: 'blur'
          }],
        checkPass: [
          { required: true, message: '请输入确认密码' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    // 获取加密密钥
    // eslint-disable-next-line no-unreachable
    getPublicKey().then(res => {
      this.secretKey = res.data
    })
  },
  methods: {

    onShowPwd() {
      this.showPwd = true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const publicKey = this.secretKey// 从服务器端获取到RSA加密公钥
          console.log(this.secretKey, '2222')
          const encrypt = new JSEncrypt()
          encrypt.setPublicKey(publicKey)
          const originalData = this.form.password

          const encryptedData = encrypt.encrypt(originalData)

          this.commitLoading = true
          changePassword(encryptedData).then(() => {
            this.$message.success('修改成功')
            this.handleClose()
          }).finally(() => {
            this.commitLoading = false
          })
        } else {
          return false
        }
      })
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
      this.showPwd = false
    },
    getNameBg() {
      const colors = ['#409EFF', '#1890ff', '#304156', '#212121', '#11a983', '#13c2c2', '#6959CD', '#f5222d']
      return colors[Math.floor(Math.random() * colors.length)]
    },
    getFirstName() {
      const arr = this.name.split(' ')
      return arr.map(k => k.substring(0, 1)).join('')
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 15px;

      .avatar-wrapper {
        //margin-top: 5px;
        position: relative;

        .name {
          display: inline-block;
          vertical-align: center;
          font-size: 15px;
        }

        .name-first {
          vertical-align: center;
          display: inline-block;
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          text-align: center;
          line-height: 40px;
          background-color: #0a76a4;
          color: #ffffff;
          margin-right: 5px;
        }

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
